import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ActionCardComponent extends Vue {
    @Prop({ type: String }) public title: string;
}
